import React, {Component} from 'react';
import isMobile from 'ismobilejs';

import {Link} from 'components/ReactRouterDomLocalized';
import AmateurFilmsList from 'components/list/AmateurFilmList';

import {t} from 'l10n'

import paths from 'paths';

import 'sass/profile/ProfileAmateurFilmsBlock.scss';

class ProfileAmateurFilmsBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        let {amateurFilms, sectionNumber, match} = this.props,
            {list, totalCount} = amateurFilms;

        return (
            <aside className={'amateur-films-main ' + ((sectionNumber % 2)==0?'even':'odd')}>
                <div className="content">
                    <div className="heading">
                        <h2>{t('Amateur videos')} <em>{totalCount}</em></h2>
                        {(list.length && !isMobile.any) ? <Link to={paths.profileAmateurFilms.toPath({nick: match.params.nick})} className="list-items">{t('See all amateur videos')}</Link> : null}
                    </div>

                    <AmateurFilmsList amateurFilms={list} altThumbnail singleRow/>

                    {(list.length && isMobile.any) ? <Link to={paths.profileAmateurFilms.toPath({nick: match.params.nick})} className="get-all-films">{t('See all amateur videos')}</Link> : <div className="view-all-placehoder"></div>}
                </div>
            </aside>
        )
    }
}

export default ProfileAmateurFilmsBlock;


// WEBPACK FOOTER //
// ./src/components/profile/ProfileAmateurFilmsBlock.js